/**
 * Derive sync-queue entityType / entityId from REST path.
 * API paths use singular segments (/athlete/create); syncController expects plural keys (athletes).
 */

const SEGMENT_TO_SYNC_ENTITY = {
  athlete: 'athletes',
  trainer: 'trainers',
  program: 'programs',
  diet: 'diets',
  daybook: 'daybooks',
  gym: 'gyms',
  payment: 'payments',
  membership: 'memberships',
  exercises: 'exercises',
  meals: 'meals',
  lockers: 'lockers',
  notifications: 'notifications',
  settings: 'settings',
};

function isMongoObjectId(value) {
  return typeof value === 'string' && /^[a-fA-F0-9]{24}$/.test(value);
}

/**
 * @param {string} url - Relative API path, e.g. /athlete/create
 * @param {string} method - HTTP method
 * @param {object} [payload]
 * @returns {{ entityType: string, entityId: string }}
 */
export function inferQueuedMutationMeta(url, method, payload = {}) {
  const path = (url || '').split('?')[0];
  const parts = path.split('/').filter(Boolean);
  const rawSeg = (parts[0] || '').toLowerCase();
  const seg = rawSeg === 'daybook' ? 'daybook' : rawSeg;

  let entityType = SEGMENT_TO_SYNC_ENTITY[seg];
  if (!entityType && path.toLowerCase().includes('daybook')) {
    entityType = 'daybooks';
  }
  if (!entityType) {
    entityType = 'default';
  }

  const last = parts[parts.length - 1] || '';

  let entityId = 'pending';

  if (method === 'PUT' || method === 'DELETE') {
    if (isMongoObjectId(last)) {
      entityId = last;
    } else if (isMongoObjectId(payload?._id)) {
      entityId = String(payload._id);
    } else if (isMongoObjectId(payload?.id)) {
      entityId = String(payload.id);
    } else if (isMongoObjectId(payload?.athleteId)) {
      entityId = String(payload.athleteId);
    } else {
      entityId = last && last !== 'update' && last !== 'delete' ? last : 'unknown';
    }
  }

  if (method === 'POST') {
    const pid =
      payload?._id ??
      payload?.id ??
      payload?.clientRequestId;
    entityId = pid != null ? String(pid) : 'pending';
  }

  return { entityType, entityId };
}
